const HTTP_STATUS = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
}

const MESSAGES = {
  UNEXPECTED_ERROR: "Beklenmedik bir hata oluştu.",
  SUCCESS: "İşlem başarılı.",
  UNAUTHORIZED_ACCESS: "Yetkisiz erişim!",
  LOGIN_FAILED: "Giriş başarısız!"
}

const APP_URL = "https://armagan.buyukresim.net"

const USER_TYPES = ["A", "B", "C", "D"]

const itIsRequired = (it) => `${it} gerekli!`

const itIsInvalid = (it) => `${it} geçersiz!`

const itIsNotFound = (it) => `${it} bulunamadı!`

const monthNames = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"]
const monthShortNames = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"]
const monthsInitials = ["O", "Ş", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"]

const chartTypes = {
  weekly: "weekly",
  monthly: "monthly"
}

const yearlySalePageNames = {
  shop: "Mağaza",
  brand: "Marka",
  productGroup: "Ürün Grubu",
  topProductGroup: "Üst Ürün Grubu"
}

export {
  HTTP_STATUS,
  MESSAGES,
  APP_URL,
  USER_TYPES,
  itIsRequired,
  itIsInvalid,
  itIsNotFound,
  monthNames,
  monthShortNames,
  monthsInitials,
  chartTypes,
  yearlySalePageNames
}
